import React, { lazy, Suspense } from 'react'

import styled from 'styled-components'

const Lottie = lazy(() => import('lottie-react'))

// Define props for the component
interface LottieAnimationProps {
  animationData: any
  width?: number | string
  height?: number | string
}

// Styled component for the animation container
const AnimationContainer = styled.div<{
  width: number | string
  height: number | string
}>`
  width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width)};
  height: ${({ height }) => (typeof height === 'number' ? `${height}px` : height)};
  display: flex;
  justify-content: center;
  align-items: center;
`

const LottieAnimation: React.FC<LottieAnimationProps> = ({
  animationData,
  width = '100%',
  height = '100%',
}) => {
  return (
    <Suspense fallback={null}>
      <AnimationContainer width={width} height={height}>
        <Lottie
          animationData={animationData}
          autoPlay
          loop
          rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
          height={height}
          width={width}
          style={{ height, width }}
        />
      </AnimationContainer>
    </Suspense>
  )
}

export default LottieAnimation
